// 巡检地图
import React, { useRef, useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom'
import { message, Checkbox, Card, Divider, Select, Layout, Button, InputNumber, Switch } from 'antd'
import {
  SaveOutlined, PlusOutlined, BlockOutlined,
  EditOutlined, CheckOutlined, SyncOutlined, MenuOutlined,
  DeleteOutlined, VerticalAlignBottomOutlined
} from '@ant-design/icons';
import { Input } from 'antd'
import {
  Amap as RMap, config as AmapReactConfig, Marker as AmapMarker, Markers as AmapMarkers,
  BezierCurve,
  Scale, TileLayer
} from '@amap/amap-react';
import { transformGCJ2WGS, transformWGSGCJ2 } from "@/common/js/common.js" //引入公共方法
import { GetRoutesPoint, SetRoutesPoint, GetRoutesPointAction, SetRoutesPointAction, GetRoutesInfo, SetTakeOff, GetAltitude } from '@/services/shipping_line' //接口
import home from "@/common/img/shipping_line/home.png" //起飞点
import waypoint from "@/common/img/shipping_line/waypoint.svg" //航点
import waypointCheck from "@/common/img/shipping_line/waypoint_check.svg" //航点
import dayjs from 'dayjs';
import local from '@/utils/local'
import img from '@/common/img/img.jpg'

import './pipeline_gad_map_show.css'
const { Content } = Layout;

AmapReactConfig.key = '193db6af15a86cd8d48b102ab461b002';

function NewGodMap() {
  const location = useLocation();//接受传值数据
  const PID = location.search.slice(1);//航线id
  // const token = localStorage.getItem('cruise_m350_token');
  const token = local.get('cruise_m350_token');

  const num = 1;//拍照 幅宽幅长比例参数

  const mapRef = useRef();
  const [zoom, setZoom] = useState(17); //地图缩放比例
  const scale = 3875.8509003722434;
  const [mapScale, setmapScale] = useState(3875.8509003722434) // 地图比例尺
  const [center_point, setCenterPoint] = useState([116.480881, 39.989410]);//地图中心点
  const [opacity, setOpacity] = useState(true);//切换图层
  const mapkeys = [
    'a7949fb4483bf7cab3a9201e8f02d352',
    '61fe9c83872647abc06719957a3d9167',
    '85d9829b132f3c11c0f834a6c7fdff35'
  ];//天地图key
  const [choose_map_key, setChooseMapKey] = useState(0);//随机 0，1，2从 mapkeys 中取一个地图key

  const [line_data, setLineData] = useState([]);//航线数据
  const [markers, setMarkers] = useState([]);//航点
  const [HomeMarkerInfo, setHomeMarker] = useState({
    type: 1,
    point: [center_point[0], center_point[1]],
    flight_height: '',//飞行高度 || 到达高度
    return_height: '',//返航高度
    uplift_speed: '',//抬升速度
    cruise_speed: '',//巡航速度
    waypoint_speed: '',//航点速度
    // photograph_type: [1],//拍照类型
    // waypoint_remain: true,//航点停留
  });
  const [curName, setCurName] = useState({
    title: '',//子管线
    Rtitle: '',//主管线
  })//当前的头部信息


  //航点点击执行
  const MarkerClick = async (idx) => {
    let lists = [...markers];
    for (let i = 0; i < lists.length; i++) {
      let val = lists[i];
      if (i === idx) {
        if (lists[i].is_check) {

        } else {
          lists[i].is_check = true;
          // return;
        }
      } else {
        lists[i].is_check = false;
      }
    }
    setMarkers([...lists])
  }


  //俯仰度为 -90时
  const GetWidthNew = (data, _scale) => {
    let obj = {
      type: data.type,
      multiple: data.multiple,
      height: data.height
    }
    let yaw_angle = data.yaw_angle;//偏航角
    let leave_height = data.leave_height;//离开高度
    let hypotenuse = 0;//斜边
    let current_focal_length = 0;//当前焦距
    let new_hypotenuse = 0;//实际斜边
    if (obj.type === 'zoom') {  //变焦
      //变焦镜头 1/1.7"CMOS
      //焦距范围 6.83 ~ 119.94 mm
      //等效焦距范围 31.7 ~ 556.2 mm
      //传感器宽高 	7.6 * 5.7  斜边 9.5  宽:斜 4:5 高:斜  3:5
      let min_focal = 6.83;//最小焦距 mm
      let max_focal = 119.94;//最大焦距 mm
      let equivalent_min_focal = 31.7;//最小等效焦距
      let equivalent_max_focal = 556.2;//最大等效焦距
      let ratio = equivalent_max_focal / max_focal;//最大等效焦距 与 最大焦距的比值 约等于 4.6 
      console.log('比值', ratio);
      hypotenuse = 9.5;//斜边
      current_focal_length = obj.multiple * 24 / ratio;//当前焦距  (变焦相机等效焦距 = 倍数（最小2，最大23） * 广角相机等效焦距（24）) / ratio
      console.log('当前', current_focal_length);
      new_hypotenuse = parseFloat((obj.height * hypotenuse) / current_focal_length);//实际斜边
    }
    if (obj.type === 'wide') { //广角
      //广角镜头 1/2.3"CMOS
      //焦距 4.5 mm
      //传感器宽高 6.16 * 4.62  斜边 7.7 宽:斜 4:5 高:斜  3:5
      hypotenuse = 7.7;//斜边
      current_focal_length = 4.5;//当前焦距
      new_hypotenuse = parseFloat(2 * (obj.height * (hypotenuse / 2) / current_focal_length));//实际斜边
    }
    if (obj.type === 'ir') { //热成像
      // DFOV：40.6°
      let angle = (90 - (40.6 / 2)) * (Math.PI / 180);//角度
      new_hypotenuse = parseFloat(2 * (obj.height / Math.tan(angle)));
    }
    let _width = parseFloat((new_hypotenuse * 4) / 5).toFixed(2);//幅宽
    let _height = parseFloat((new_hypotenuse * 3) / 5).toFixed(2);//幅高
    console.log('幅宽', _width);
    console.log('幅高', _height);
    var width = parseFloat((_width * (scale / _scale)).toFixed(2));
    var height = parseFloat((_height * (scale / _scale)).toFixed(2));
    let angle = Math.asin(3 / 5) * (180 / Math.PI);
    let len = [
      { len: parseFloat((new_hypotenuse / 2) * (scale / mapScale)).toFixed(2), angle: parseFloat(angle).toFixed(2) },
      { len: parseFloat((new_hypotenuse / 2) * (scale / mapScale)).toFixed(2), angle: parseFloat(angle).toFixed(2) },
      { len: 0, angle: parseFloat(90).toFixed(2) },
    ]
    //
    return [width, width, height, (height / 2 * -1), len, yaw_angle, leave_height]

  }

  //俯仰度 小于0并且大于-90时
  //相机的拍摄区域与飞行高度、无人机偏航角度、摄像头的俯仰角度有关，如果是变焦相机还与变焦有关
  const GetWidthNew2 = (data, _scale) => {
    let obj = {
      type: 1,
      multiple: 5,
      pitch_angle: 90,//俯仰角度
      height: Number(data.flight_height) || 80,//飞行高度  || 到达高度
    }
    let yaw_angle = 0;
    let leave_height = obj.height;
    //根据动作 获取对应的高度、偏航角度、俯仰角度等信息
    //只有在“拍照”动作之前的动作才会在计算之内
    if (data.action && data.action.length >= 0) {
      let types = data.action.map((item) => { return item.type });
      let idx = types?.indexOf(5);
      for (let i = 0; i < data.action.length; i++) {
        let val = data.action[i];
        switch (val.type) {
          case 1://抬升高度
            leave_height = leave_height + Number(val.uplift_height);
            if (i < idx && idx >= 0) { obj.height = obj.height + Number(val.uplift_height); };
            break;
          case 2://下降高度
            leave_height = leave_height - Number(val.decline_height);
            if (i < idx && idx >= 0) { obj.height = obj.height - Number(val.decline_height); };
            break;
          case 3://偏航角
            if (i < idx && idx >= 0) { yaw_angle = val.yaw_angle } break;
          case 15://无人机偏航角
            if (i < idx && idx >= 0) { yaw_angle = val.UAV_angle } break;
          case 4://俯仰角
            if (i < idx && idx >= 0) { obj.pitch_angle = Number(val.pitch_angle) + 90; } break;
          case 7://变焦
            if (i < idx && idx >= 0) { obj.multiple = Number(val.zoom); } break;
          case 5:
            if (val.photograph_type.length > 0) { obj.type = val.photograph_type[0]; }; break;
          default: break;
        }
      }
      if (idx === -1) { //没有拍照，直接退出
        let len = [
          { len: 0, angle: 0 },
          { len: 0, angle: 0 },
          { len: 0, angle: 0 }
        ];
        return [0, 0, 0, 0, len, yaw_angle, leave_height]
      }
    } else {
      let len = [
        { len: 0, angle: 0 },
        { len: 0, angle: 0 },
        { len: 0, angle: 0 }
      ];
      return [0, 0, 0, 0, len, yaw_angle, leave_height]
    }
    if (obj.pitch_angle === 0) {
      let o = {
        type: obj.type,
        multiple: obj.multiple,
        height: obj.height,
        yaw_angle: yaw_angle,
        leave_height: leave_height,
      }
      return GetWidthNew(o, _scale)
    }

    if (obj.pitch_angle === 90) {
      let len = [
        { len: Math.floor(Math.sqrt(50000) * (scale / mapScale)), angle: 63.46 },
        { len: Math.floor(Math.sqrt(50000) * (scale / mapScale)), angle: 63.46 },
        { len: Math.floor(200 * (scale / mapScale)), angle: 90 },
      ]
      return [
        Math.floor(200 * (scale / mapScale)),
        Math.floor(200 * (scale / mapScale)),
        2,
        Math.floor(200 * (scale / mapScale)),
        len,
        yaw_angle,
        leave_height
      ]
    }
    let w = 0;//宽
    let h = 0;//高
    let focal_length = 0;//当前焦距

    if (obj.type === 'zoom') { //变焦
      //变焦镜头 1/1.7"CMOS
      //焦距范围 6.83 ~ 119.94 mm
      //等效焦距范围 31.7 ~ 556.2 mm
      //传感器宽高 	7.6 * 5.7  斜边 9.5  宽:斜 4:5 高:斜  3:5
      let min_focal = 6.83;//最小焦距 mm
      let max_focal = 119.94;//最大焦距 mm
      let equivalent_min_focal = 31.7;//最小等效焦距
      let equivalent_max_focal = 556.2;//最大等效焦距
      let ratio = equivalent_max_focal / max_focal;//最大等效焦距 与 最大焦距的比值 约等于 4.6 
      let hypotenuse = 9.5;//斜边
      w = 7.6;
      h = 5.7;
      focal_length = obj.multiple * 24 / ratio;//当前焦距  (变焦相机等效焦距 = 倍数（最小2，最大23） * 广角相机等效焦距（24）) / ratio 
    }

    if (obj.type === 'wide') { //广角
      //广角镜头 1/2.3"CMOS
      //焦距 4.5 mm
      //传感器宽高 6.16 * 4.62  斜边 7.7 宽:斜 4:5 高:斜  3:5
      w = 6.16;
      h = 4.62;
      let hypotenuse = 7.7;//斜边
      focal_length = 4.5;//当前焦距
    }

    if (obj.type === 'ir') { //热成像
      // DFOV：40.6°
      // 焦距：13.5 mm
      let tan = 0.37; // tan(40.6/2) 约等于
      let hypotenuse = 5; //斜边 focal_length * tan 约等于
      w = 4;
      h = 3;
      focal_length = 13.5;
    }

    //开始计算相机拍摄区域
    let AH = obj.height / Math.cos((obj.pitch_angle) * (Math.PI / 180)); //邻边比斜边
    let j_DAI = 2 * Math.asin((h / 2) / (Math.sqrt(Math.pow((h / 2), 2) + Math.pow(focal_length, 2)))) * (180 / Math.PI); // 角DAI的角度
    let AD = obj.height / Math.cos(((j_DAI / 2) + obj.pitch_angle) * (Math.PI / 180));
    let j_BAC = 2 * Math.asin((w / 2) / Math.sqrt(Math.pow(Math.sqrt(Math.pow(w, 2) + Math.pow(h, 2)) / 2, 2) + Math.pow(focal_length, 2))) * (180 / Math.PI);

    let AC = AD / Math.cos((j_BAC / 2) * (Math.PI / 180));
    let DC = Math.sqrt(Math.pow(AC, 2) - Math.pow(AD, 2));
    let BC = 2 * DC;
    let DH = Math.sqrt(Math.pow(AD, 2) + Math.pow(AH, 2) - (Math.cos((j_DAI / 2) * (Math.PI / 180)) * 2 * AD * AH));
    let j_AHG = 90 - obj.pitch_angle;
    let j_HAI = j_DAI / 2;
    let j_AIH = 180 - j_AHG - j_HAI;
    let HI = AH * Math.sin(j_HAI * (Math.PI / 180)) / Math.sin(j_AIH * (Math.PI / 180));
    let FE = HI * BC / DH;
    let DI = DH + HI;
    let HG = Math.sqrt(Math.pow(AH, 2) - Math.pow(obj.height, 2));
    let DG2 = Math.pow(AD, 2) - Math.pow(obj.height, 2);
    let CG = Math.sqrt(Math.pow(DC, 2) + DG2);
    let j_DCG = Math.acos(DC / CG) * (180 / Math.PI);

    // let IA = (FE / 2) / Math.tan((j_BAC / 2) * (Math.PI / 180));

    let IG = obj.height * Math.tan((obj.pitch_angle - j_HAI) * (Math.PI / 180));
    let EG = Math.sqrt(Math.pow(IG, 2) + Math.pow(FE / 2, 2));
    let j_IEG = Math.acos((FE / 2) / EG) * (180 / Math.PI);
    let len = [
      { len: Math.floor(EG * (scale / mapScale)), angle: parseFloat(j_IEG).toFixed(2) },
      { len: Math.floor(CG * (scale / mapScale)), angle: parseFloat(j_DCG).toFixed(2) },
      { len: Math.floor(HG * (scale / mapScale)), angle: 90 },
    ]
    return [
      Math.floor(BC * (scale / mapScale)),//梯形上底
      Math.floor(FE * (scale / mapScale)),//梯形下底
      Math.floor(DI * (scale / mapScale)),//梯形高
      Math.floor((HG - HI) * (scale / mapScale)),//偏移
      len,//线 中心点到梯形4个点的距离
      yaw_angle,//旋转角度
      leave_height,//离开高度
    ]

  }

  //获取航点| 管线节点  1 管线节点  2 航点
  const GetRoutesPointFun = async (type, c) => {
    let res = await GetRoutesPoint({
      access_token: token,
      id: PID,//航线id
      type: type || 1
    });
    if (res.ret !== 200) {
      message.warning(res.msg || '系统出错了');
      return c();
    }
    if (!res.data.length || res.data.length === 0) {
      message.warning('暂无管线节点');
      return c();
    }
    let arr = res.data.map((item) => {
      let d = transformGCJ2WGS({ lat: item.latitude, lon: item.longitude });
      return [Number(parseFloat(d.lon).toFixed(7)), Number(parseFloat(d.lat).toFixed(7))];
    })
    setLineData([...arr]);
    return c(arr[0])
  }

  //获取管线详细信息以及起飞点信息
  const GetRoutesInfoFun = async (point) => {
    let obj = {
      access_token: token,
      id: PID,
    }
    let res = await GetRoutesInfo(obj);
    if (res.ret !== 200) {
      message.warning(res.msg || '系统出错了');
      return;
    }
    let val = res.data;
    let d
    if (val.latitude && val.longitude) {
      let p = transformGCJ2WGS({ lat: val.latitude, lon: val.longitude });
      d = [Number(parseFloat(p.lon).toFixed(7)), Number(parseFloat(p.lat).toFixed(7))]
    } else { //如果起飞点的经纬度为空，则显示管线的第一个点，没有则显示成都的经纬度
      if (point) {
        d = point;
      } else {
        d = [104.06, 30.67];
      }
    }
    setCenterPoint(d);
    let info = {
      id: val.id,
      point: d,
      flight_height: Number(val.takeoffaltitude) || 0,//飞行高度 || 到达高度
      return_height: Number(val.gohomealtitude) || 0,//返航高度
      uplift_speed: Number(val.safespeed) || 0,//抬升速度
      cruise_speed: Number(val.curspeed) || 0,//巡航速度
      waypoint_speed: Number(val.waypointspeed) || 0//航点速度
    }
    setHomeMarker({ ...info });
    let cur = curName;
    cur.title = res.data.title;
    cur.Rtitle = res.data.Rtitle;
    setCurName({ ...cur })
  }

  //获取航点以及航点动作
  const GetRoutesPointActionFun = async () => {
    let obj = {
      access_token: token,
      id: PID
    }
    let res = await GetRoutesPointAction(obj);
    if (res.ret !== 200) {
      message.warning(res.msg || '系统出错了');
      return;
    }
    if (!res.data.length || res.data.length === 0) { //没有航点
      return;
    }
    let arr = [];
    let altitudes_list = [];
    for (let i = 0; i < res.data.length; i++) {
      let item = res.data[i];
      let d = transformGCJ2WGS({ lat: item.latitude, lon: item.longitude });
      let obj = {
        id: item.id,
        name: item.name,
        // point: [Number(parseFloat(d.lon).toFixed(7)), Number(parseFloat(d.lat).toFixed(7))],
        point: [Number(item.wgs84_longitude), Number(item.wgs84_latitude)],
        flight_height: Number(item.altitude) || 0,//飞行高度 || 到达高度
        yaw_angle: 0,//偏航角度
        src: item.pic,
        action: [],//动作
      }
      altitudes_list.push(Number(item.asl));//地表海拔 海拔(高程)

      if (item.aclist && item.aclist.length > 0) {

        obj.action = item.aclist.map((val) => {
          let obj_action = {
            type: val.type,
            uplift_height: '',//抬升高度
            decline_height: '',//下降高度
            UAV_angle: '',//无人机偏航角度
            yaw_angle: '',//云台偏航角度
            pitch_angle: '',//俯仰角度
            zoom: '',//变焦倍数
            photograph_type: [],//拍照类型
            readout_type: null,//读数 - 显表类型
            readout_unit: '',//读数 - 数据单位
            readout_range: ['', ''],//读数 - 合理范围
            temperature_range: ['', ''],//温度 - 合理范围
            photography_state: true,//摄像是否开启
            lighting_state: true,//照明辅助是否开启
          }
          switch (val.type) {
            case 1: obj_action.uplift_height = Number(val.value); break;
            case 2: obj_action.decline_height = Number(val.value); break;
            case 3: obj_action.yaw_angle = val.value; obj.yaw_angle = val.value; break;//云台偏航角
            case 4: obj_action.pitch_angle = val.value; break;
            case 5: obj_action.photograph_type = [(val.value)]; break;
            case 6: obj_action.photography_state = (Number(val.value) === 1 ? true : false); break;
            case 7: obj_action.zoom = val.value; break;
            case 8: obj_action.readout_range = val.value !== '' ? [val.value.split('-')[0], val.value.split('-')[1]] : ['', '']; break;
            case 9: obj_action.lighting_state = (Number(val.value) === 1 ? true : false); break;
            case 10: obj_action.temperature_range = val.value !== '' ? [val.value.split('-')[0], val.value.split('-')[1]] : ['', '']; break;
            case 15: obj_action.UAV_angle = val.value; obj.UAV_angle = val.value; break;//无人机偏航角
            default:
              break;
          }
          return obj_action
        })
      }
      let wh = GetWidthNew2(obj, mapScale)
      obj.width = Number(wh[0]);
      obj.height = Number(wh[1]);
      obj.z = Number(wh[2]);
      obj.offset = Number(wh[3]);//偏移
      obj.line = wh[4];
      obj.photograph_width = parseFloat(Number(wh[0]) / (scale / mapScale)).toFixed(0);//拍照幅宽
      obj.photograph_height = parseFloat(Number(wh[2]) / (scale / mapScale)).toFixed(0);//拍照幅高
      obj.yaw_angle = Number(wh[5]);
      obj.leave_height = wh[6];
      arr.push(obj);
    }
    setMarkers([...arr]);
  }

  useEffect(() => { //页面加载完成执行
    let num = Math.floor(Math.random() * 3);
    setChooseMapKey(num);
    GetRoutesPointFun(1, (point) => {
      GetRoutesInfoFun(point);//获取起飞点信息
    });//获取管线节点
    GetRoutesPointActionFun();//获取航点以及动作

    //eslint-disable-next-line
  }, [])

  //地图放大缩小执行
  useEffect(() => {
    if (markers && markers.length === 0) {
      return;
    }
    let arr = [...markers];
    for (let i = 0; i < arr.length; i++) {
      let val = arr[i];
      let wh = GetWidthNew2(val, mapScale);
      val.width = Number(wh[0]);
      val.height = Number(wh[1]);
      val.z = Number(wh[2]);
      val.offset = Number(wh[3]);
      val.line = wh[4];
      val.photograph_width = parseFloat(Number(wh[0]) / (scale / mapScale)).toFixed(0);//拍照幅宽
      val.photograph_height = parseFloat(Number(wh[2]) / (scale / mapScale)).toFixed(0);//拍照幅高
      val.yaw_angle = Number(wh[5]);
      val.leave_height = wh[6];
    }
    setMarkers([...arr]);
    //eslint-disable-next-line
  }, [mapScale])

  return (
    <div style={{ height: '100vh' }}>
      {/* 地图 */}
      <RMap
        // mapStyle="amap://styles/whitesmoke"
        features={[]}
        ref={mapRef}
        zoom={zoom}
        center={center_point}
        onZoomChange={(map) => {
          // zoom 最大20 最小2
          setZoom(map.getZoom());
          setmapScale(map.getScale())
        }}
      >
        {/* 天地图图层 */}
        <TileLayer getTileUrl={'http://t4.tianditu.gov.cn/DataServer?T=vec_w&tk=' + mapkeys[choose_map_key] + '&x=[x]&y=[y]&l=[z]'} />
        <TileLayer getTileUrl={'http://t0.tianditu.gov.cn/DataServer?T=img_w&tk=' + mapkeys[choose_map_key] + '&x=[x]&y=[y]&l=[z]'} opacity={opacity} />
        <TileLayer getTileUrl={'http://t4.tianditu.gov.cn/DataServer?T=cia_w&tk=' + mapkeys[choose_map_key] + '&x=[x]&y=[y]&l=[z]'} />

        {/* 管线 */}
        {/* {
                    line_data.length > 0 ? (
                        <BezierCurve
                            path={line_data}
                            isOutline={true}
                            outlineColor="white"
                            borderWeight={2}
                            strokeColor="#00B5FF"
                            strokeOpacity={1}
                            strokeWeight={4}
                            strokeStyle="solid" // 线样式还支持 'dashed'
                            // strokeStyle是dashed时有效
                            // strokeDasharray={[4, 4]}  //0 设置线段粗细  1 设置线段粗细间隔
                            zIndex={50}
                        />) : ''
                } */}

        {/* 起飞点 */}
        {
          HomeMarkerInfo && JSON.stringify(HomeMarkerInfo) !== '{}' ? (<AmapMarker
            visiable="true"
            draggable={false}
            position={HomeMarkerInfo.point}
            zIndex={99999}
            offset={[0, 0]}
          ><img alt='起飞点' style={{
            width: "48px",
            height: "48px"
          }} src={home}></img></AmapMarker>) : null
        }

        {/* 航点 */}
        {
          markers && markers.length > 0 ? (
            markers.map((val, idx) => {
              return (
                <AmapMarker
                  features={[]}
                  key={idx}
                  visiable={true}
                  draggable={false}
                  position={val.point}
                  extData={idx}
                  offset={[0, 11]} //偏移量
                  onClick={() => { //点击执行
                    MarkerClick(idx);
                  }}
                  angle={val.yaw_angle}
                  // angle={0}
                  onDragStart={() => {
                    if (val.is_check) return;
                    MarkerClick(idx);
                  }}
                  onDragEnd={(m) => {
                    let lnglat = m.getPosition();
                    onWaypointDragEnd(m.getExtData(), lnglat);
                  }}
                >
                  {/* 航点 */}
                  <div className='pos_rel ' style={{ zIndex: 102, }}>
                    <img alt="航点选中" src={waypoint} style={{ width: '22px', height: '22px', display: val.src ? 'none' : '' }}></img>
                    <div style={{ width: '22px', height: '22px', display: val.src ? '' : 'none' }}></div>
                  </div>
                  <div className='pos_abs ' style={{
                    overflow: 'hidden',
                    display: val.src ? '' : 'none',
                    zIndex: 10,
                    width: val.width * num + 'px',
                    height: val.z * num + 'px',
                    top: (-((val.z) / 2) + 11) * num + 'px',
                    // top: 11 + 'px',
                    left: (-((val.width) / 2) + 11) * num + 'px',
                    // left: 11 + 'px',
                  }}>
                    <img alt='拍照' src={val.src} style={{ width: val.width * num + 'px', height: val.z * num + 'px', zIndex: 9 }}></img>
                  </div>

                </AmapMarker>
              )
            })
          ) : ''
        }
        <Scale position={{ bottom: '24px', left: '4px' }} /> {/* 比例尺 */}
        {/* <Toolbar position={{ bottom: '24px', right: '20px' }} /> 按钮缩放 */}

      </RMap>

      {/* 功能按钮 */}
      <div className="pos_abs flex-col" style={{ top: 0 }}>
        {/* 按钮 */}
        <div className='flex-row mar24 radius8 hidden'>
          <div className='flex jcc align_center'>
            {/* 切换 */}
            <div
              className='flex jcc align_center pointer'
              style={{
                background: '#1F1F1F',
                borderRight: '1px solid rgba(255,255,255,0.1)'
              }}
              onClick={() => {
                setOpacity(!opacity)
              }}
            >
              <BlockOutlined className="mar12 w16 h16" style={{ color: 'white' }} />
            </div>

            {
              curName &&
              <div className='h40' style={{ background: '#1F1F1F' }}>
                <div className='pdTB8 pdRL12 lh24 fw600 fs16' style={{ color: 'white' }}>
                  {curName.Rtitle}
                  {
                    curName.Rtitle &&
                    <span>&nbsp;-&nbsp;</span>
                  }
                  {curName.title}
                </div>
              </div>
            }
          </div>

          <div className='flex-auto'></div>
        </div>
      </div>
    </div>
  );
};

export default NewGodMap;